import BaseService from './BaseService';

class AwareExposeService extends BaseService {
    publicConfig(key) {
        return this.get(`/public/aware-expose/${encodeURIComponent(key)}/config`);
    }

    publicScan(key, payload) {
        return this.post(
            `/public/aware-expose/${encodeURIComponent(key)}/scan`,
            payload
        );
    }

    publicAttacks(key, payload) {
        return this.post(
            `/public/aware-expose/${encodeURIComponent(key)}/attacks`,
            payload
        );
    }

    config(companyId) {
        return this.get('/aware-expose/config', { companyId });
    }

    lastRun(companyId) {
        return this.get('/aware-expose/runs/last', { companyId });
    }

    history(companyId, limit) {
        return this.get('/aware-expose/runs', { companyId, limit });
    }

    scan(companyId, person, extras = {}) {
        return this.post('/aware-expose/scan', {
            companyId,
            ...person,
            ...extras,
        });
    }

    attacks(companyId, runId) {
        return this.post('/aware-expose/attacks', { companyId, runId });
    }

    pins(companyId) {
        return this.get('/aware-expose/pins', { companyId });
    }

    addPin(companyId, { source, text, weight } = {}) {
        return this.post('/aware-expose/pins', {
            companyId,
            source,
            text,
            weight,
        });
    }

    removePin(companyId, pinId) {
        return this.del(
            `/aware-expose/pins/${encodeURIComponent(pinId)}?companyId=${encodeURIComponent(
                companyId
            )}`
        );
    }
}

export default AwareExposeService;
